/* generated by packages/ui/tokens/build-m3.mjs */
/*
 * ค่าสีเป็นสตริง สำหรับที่ที่ตัวแปร CSS เข้าไม่ถึง: วัสดุของ three.js, HTML ในอีเมล,
 * การ์ด LINE Flex และ <meta name="theme-color"> ในหน้าจอปกติให้ใช้ตัวแปร CSS เสมอ
 * แก้ที่ packages/ui/tokens/build-m3.mjs แล้วรัน `pnpm --dir packages/ui tokens:m3`
 */

/** สีแบรนด์ #B50D29 เป็นของ PREEDA NEXT เท่านั้น */
export const BRAND_HEX = {
  preedaNext: "#B50D29",
  pk: "#CF202B",
  sp: "#000000",
  cpk: "#EC2224",
  spms: "#BA0C1F",
  spmsLogo: "#ED2124",
  est: "#EB3130",
  preedaGroup: "#770200",
  personal: "#374D6F",
} as const;

/** ชื่อ `--color-*` ของ colors-and-type.css ที่ค่าเป็นเลขฐานสิบหก ตัดคำนำหน้า `--color-` ออก */
export const PALETTE = {
  "red-600": "#B50D29",
  "red-cpk": "#EC2224",
  "neutral-0": "#FFFFFF",
  "neutral-50": "#FBF9F9",
  "neutral-100": "#F0F0F0",
  "neutral-200": "#E7E7E7",
  "neutral-300": "#CCCCCC",
  "neutral-400": "#B7A8A6",
  "neutral-500": "#8E8E8E",
  "neutral-600": "#6E625F",
  "neutral-700": "#3E3533",
  "neutral-800": "#201A1A",
  "neutral-900": "#160F0E",
  "neutral-950": "#0B0706",
  "ink-950": "#1A1A1A",
  "ink-800": "#333333",
  "ink-700": "#4A4A4A",
  "ink-600": "#666666",
  "ink-500": "#757575",
  "paper-100": "#F5F5F5",
  "paper-200": "#F2F2F2",
  "paper-300": "#EBEBEB",
  "cool-300": "#6994BF",
  "cool-500": "#2E5F8A",
  gunmetal: "#1C3A5E",
  "red-crimson": "#BA0C1F",
  "red-spms-600": "#BA0C1F",
} as const;

/** `colors.brand` ของ design-tokens.json ชุดเหล็กของ PREEDA NEXT */
export const DESIGN_BRAND = {
  red: "#B50D29",
  midnight: "#000000",
  "dark-steel": "#2D2D2D",
  steel: "#B2B2B2",
  "light-steel": "#E7E7E7",
  "off-white": "#FBF9F9",
} as const;

/*
 * บทบาท M3 ต่อแบรนด์ต่อโหมด ค่าเดียวกับ packages/ui/src/styles/m3/<แบรนด์>.css
 * แยกเป็นค่าคงที่ละชุด ให้หน้าที่ต้องการสีเดียว (เช่น theme-color) นำเข้าชุดเดียว ไม่ลากทั้งตารางเข้าไฟล์ฝั่งเบราว์เซอร์
 */
export const M3_PREEDANEXT_LIGHT = {
  primary: "#8b001b",
  "on-primary": "#ffffff",
  "primary-container": "#b50d29",
  "on-primary-container": "#ffc4c2",
  secondary: "#a03d40",
  "on-secondary": "#ffffff",
  "secondary-container": "#fd8585",
  "on-secondary-container": "#741d22",
  tertiary: "#004960",
  "on-tertiary": "#ffffff",
  "tertiary-container": "#006280",
  "on-tertiary-container": "#95dcfe",
  error: "#ba1a1a",
  "on-error": "#ffffff",
  "error-container": "#ffdad6",
  "on-error-container": "#93000a",
  surface: "#f9f9f9",
  "surface-dim": "#dadada",
  "surface-bright": "#f9f9f9",
  "surface-container-lowest": "#ffffff",
  "surface-container-low": "#f3f3f3",
  "surface-container": "#eeeeee",
  "surface-container-high": "#e8e8e8",
  "surface-container-highest": "#e2e2e2",
  "on-surface": "#1b1b1b",
  "on-surface-variant": "#474747",
  outline: "#777777",
  "outline-variant": "#c6c6c6",
  "inverse-surface": "#303030",
  "inverse-on-surface": "#f1f1f1",
  "inverse-primary": "#ffb3b1",
  scrim: "#000000",
  shadow: "#000000",
  "surface-tint": "#bb142c",
  background: "#f9f9f9",
  "on-background": "#1b1b1b",
} as const;

export const M3_PREEDANEXT_DARK = {
  primary: "#ffb3b1",
  "on-primary": "#680012",
  "primary-container": "#b50d29",
  "on-primary-container": "#ffc4c2",
  secondary: "#ffb3b1",
  "on-secondary": "#620e16",
  "secondary-container": "#81262a",
  "on-secondary-container": "#ff9997",
  tertiary: "#89d0f2",
  "on-tertiary": "#003547",
  "tertiary-container": "#006280",
  "on-tertiary-container": "#95dcfe",
  error: "#ffb4ab",
  "on-error": "#690005",
  "error-container": "#93000a",
  "on-error-container": "#ffdad6",
  surface: "#131313",
  "surface-dim": "#131313",
  "surface-bright": "#393939",
  "surface-container-lowest": "#0e0e0e",
  "surface-container-low": "#1b1b1b",
  "surface-container": "#1f1f1f",
  "surface-container-high": "#2a2a2a",
  "surface-container-highest": "#353535",
  "on-surface": "#e2e2e2",
  "on-surface-variant": "#c6c6c6",
  outline: "#919191",
  "outline-variant": "#474747",
  "inverse-surface": "#e2e2e2",
  "inverse-on-surface": "#303030",
  "inverse-primary": "#bb142c",
  scrim: "#000000",
  shadow: "#000000",
  "surface-tint": "#ffb3b1",
  background: "#131313",
  "on-background": "#e2e2e2",
} as const;

export const M3_PK_LIGHT = {
  primary: "#a90019",
  "on-primary": "#ffffff",
  "primary-container": "#cf202b",
  "on-primary-container": "#ffe6e4",
  secondary: "#a43b38",
  "on-secondary": "#ffffff",
  "secondary-container": "#fc7d77",
  "on-secondary-container": "#711517",
  tertiary: "#005878",
  "on-tertiary": "#ffffff",
  "tertiary-container": "#00729a",
  "on-tertiary-container": "#d7efff",
  error: "#ba1a1a",
  "on-error": "#ffffff",
  "error-container": "#ffdad6",
  "on-error-container": "#93000a",
  surface: "#f9f9f9",
  "surface-dim": "#dadada",
  "surface-bright": "#f9f9f9",
  "surface-container-lowest": "#ffffff",
  "surface-container-low": "#f3f3f3",
  "surface-container": "#eeeeee",
  "surface-container-high": "#e8e8e8",
  "surface-container-highest": "#e2e2e2",
  "on-surface": "#1b1b1b",
  "on-surface-variant": "#474747",
  outline: "#777777",
  "outline-variant": "#c6c6c6",
  "inverse-surface": "#303030",
  "inverse-on-surface": "#f1f1f1",
  "inverse-primary": "#ffb3ae",
  scrim: "#000000",
  shadow: "#000000",
  "surface-tint": "#bd0d21",
  background: "#f9f9f9",
  "on-background": "#1b1b1b",
} as const;

export const M3_PK_DARK = {
  primary: "#ffb3ae",
  "on-primary": "#68000b",
  "primary-container": "#cf202b",
  "on-primary-container": "#ffe6e4",
  secondary: "#ffb3ae",
  "on-secondary": "#640a10",
  "secondary-container": "#842323",
  "on-secondary-container": "#ff9993",
  tertiary: "#80d0fc",
  "on-tertiary": "#003549",
  "tertiary-container": "#00729a",
  "on-tertiary-container": "#d7efff",
  error: "#ffb4ab",
  "on-error": "#690005",
  "error-container": "#93000a",
  "on-error-container": "#ffdad6",
  surface: "#131313",
  "surface-dim": "#131313",
  "surface-bright": "#393939",
  "surface-container-lowest": "#0e0e0e",
  "surface-container-low": "#1b1b1b",
  "surface-container": "#1f1f1f",
  "surface-container-high": "#2a2a2a",
  "surface-container-highest": "#353535",
  "on-surface": "#e2e2e2",
  "on-surface-variant": "#c6c6c6",
  outline: "#919191",
  "outline-variant": "#474747",
  "inverse-surface": "#e2e2e2",
  "inverse-on-surface": "#303030",
  "inverse-primary": "#bd0d21",
  scrim: "#000000",
  shadow: "#000000",
  "surface-tint": "#ffb3ae",
  background: "#131313",
  "on-background": "#e2e2e2",
} as const;

export const M3_SP_LIGHT = {
  primary: "#000000",
  "on-primary": "#e2e2e2",
  "primary-container": "#3b3b3b",
  "on-primary-container": "#ffffff",
  secondary: "#5e5e5e",
  "on-secondary": "#ffffff",
  "secondary-container": "#d4d4d4",
  "on-secondary-container": "#1b1b1b",
  tertiary: "#3b3b3b",
  "on-tertiary": "#e2e2e2",
  "tertiary-container": "#747474",
  "on-tertiary-container": "#ffffff",
  error: "#ba1a1a",
  "on-error": "#ffffff",
  "error-container": "#ffdad6",
  "on-error-container": "#410002",
  surface: "#f9f9f9",
  "surface-dim": "#dadada",
  "surface-bright": "#f9f9f9",
  "surface-container-lowest": "#ffffff",
  "surface-container-low": "#f3f3f3",
  "surface-container": "#eeeeee",
  "surface-container-high": "#e8e8e8",
  "surface-container-highest": "#e2e2e2",
  "on-surface": "#1b1b1b",
  "on-surface-variant": "#474747",
  outline: "#777777",
  "outline-variant": "#c6c6c6",
  "inverse-surface": "#303030",
  "inverse-on-surface": "#f1f1f1",
  "inverse-primary": "#c6c6c6",
  scrim: "#000000",
  shadow: "#000000",
  "surface-tint": "#5e5e5e",
  background: "#f9f9f9",
  "on-background": "#1b1b1b",
} as const;

export const M3_SP_DARK = {
  primary: "#ffffff",
  "on-primary": "#1b1b1b",
  "primary-container": "#d4d4d4",
  "on-primary-container": "#000000",
  secondary: "#c6c6c6",
  "on-secondary": "#1b1b1b",
  "secondary-container": "#474747",
  "on-secondary-container": "#e2e2e2",
  tertiary: "#e2e2e2",
  "on-tertiary": "#1b1b1b",
  "tertiary-container": "#919191",
  "on-tertiary-container": "#000000",
  error: "#ffb4ab",
  "on-error": "#690005",
  "error-container": "#93000a",
  "on-error-container": "#ffdad6",
  surface: "#131313",
  "surface-dim": "#131313",
  "surface-bright": "#393939",
  "surface-container-lowest": "#0e0e0e",
  "surface-container-low": "#1b1b1b",
  "surface-container": "#1f1f1f",
  "surface-container-high": "#2a2a2a",
  "surface-container-highest": "#353535",
  "on-surface": "#e2e2e2",
  "on-surface-variant": "#c6c6c6",
  outline: "#919191",
  "outline-variant": "#474747",
  "inverse-surface": "#e2e2e2",
  "inverse-on-surface": "#303030",
  "inverse-primary": "#5e5e5e",
  scrim: "#000000",
  shadow: "#000000",
  "surface-tint": "#c6c6c6",
  background: "#131313",
  "on-background": "#e2e2e2",
} as const;

export const M3_PERSONAL_LIGHT = {
  primary: "#1f3657",
  "on-primary": "#ffffff",
  "primary-container": "#374d6f",
  "on-primary-container": "#a8bee6",
  secondary: "#575f6e",
  "on-secondary": "#ffffff",
  "secondary-container": "#d8e0f2",
  "on-secondary-container": "#5b6372",
  tertiary: "#483200",
  "on-tertiary": "#ffffff",
  "tertiary-container": "#614815",
  "on-tertiary-container": "#dbb87a",
  error: "#ba1a1a",
  "on-error": "#ffffff",
  "error-container": "#ffdad6",
  "on-error-container": "#93000a",
  surface: "#f9f9f9",
  "surface-dim": "#dadada",
  "surface-bright": "#f9f9f9",
  "surface-container-lowest": "#ffffff",
  "surface-container-low": "#f3f3f3",
  "surface-container": "#eeeeee",
  "surface-container-high": "#e8e8e8",
  "surface-container-highest": "#e2e2e2",
  "on-surface": "#1b1b1b",
  "on-surface-variant": "#474747",
  outline: "#777777",
  "outline-variant": "#c6c6c6",
  "inverse-surface": "#303030",
  "inverse-on-surface": "#f1f1f1",
  "inverse-primary": "#b1c7f0",
  scrim: "#000000",
  shadow: "#000000",
  "surface-tint": "#495f82",
  background: "#f9f9f9",
  "on-background": "#1b1b1b",
} as const;

export const M3_PERSONAL_DARK = {
  primary: "#b1c7f0",
  "on-primary": "#193151",
  "primary-container": "#374d6f",
  "on-primary-container": "#a8bee6",
  secondary: "#bfc7d8",
  "on-secondary": "#29313e",
  "secondary-container": "#3f4756",
  "on-secondary-container": "#adb5c7",
  tertiary: "#e5c183",
  "on-tertiary": "#412d00",
  "tertiary-container": "#614815",
  "on-tertiary-container": "#dbb87a",
  error: "#ffb4ab",
  "on-error": "#690005",
  "error-container": "#93000a",
  "on-error-container": "#ffdad6",
  surface: "#131313",
  "surface-dim": "#131313",
  "surface-bright": "#393939",
  "surface-container-lowest": "#0e0e0e",
  "surface-container-low": "#1b1b1b",
  "surface-container": "#1f1f1f",
  "surface-container-high": "#2a2a2a",
  "surface-container-highest": "#353535",
  "on-surface": "#e2e2e2",
  "on-surface-variant": "#c6c6c6",
  outline: "#919191",
  "outline-variant": "#474747",
  "inverse-surface": "#e2e2e2",
  "inverse-on-surface": "#303030",
  "inverse-primary": "#495f82",
  scrim: "#000000",
  shadow: "#000000",
  "surface-tint": "#b1c7f0",
  background: "#131313",
  "on-background": "#e2e2e2",
} as const;

export const M3_PREEDAGROUP_LIGHT = {
  primary: "#4e0100",
  "on-primary": "#ffffff",
  "primary-container": "#770200",
  "on-primary-container": "#ff7965",
  secondary: "#914a3e",
  "on-secondary": "#ffffff",
  "secondary-container": "#fca192",
  "on-secondary-container": "#77352b",
  tertiary: "#000d78",
  "on-tertiary": "#ffffff",
  "tertiary-container": "#0018b4",
  "on-tertiary-container": "#8e99ff",
  error: "#ba1a1a",
  "on-error": "#ffffff",
  "error-container": "#ffdad6",
  "on-error-container": "#93000a",
  surface: "#f9f9f9",
  "surface-dim": "#dadada",
  "surface-bright": "#f9f9f9",
  "surface-container-lowest": "#ffffff",
  "surface-container-low": "#f3f3f3",
  "surface-container": "#eeeeee",
  "surface-container-high": "#e8e8e8",
  "surface-container-highest": "#e2e2e2",
  "on-surface": "#1b1b1b",
  "on-surface-variant": "#474747",
  outline: "#777777",
  "outline-variant": "#c6c6c6",
  "inverse-surface": "#303030",
  "inverse-on-surface": "#f1f1f1",
  "inverse-primary": "#ffb4a8",
  scrim: "#000000",
  shadow: "#000000",
  "surface-tint": "#af3021",
  background: "#f9f9f9",
  "on-background": "#1b1b1b",
} as const;

export const M3_PREEDAGROUP_DARK = {
  primary: "#ffb4a8",
  "on-primary": "#680200",
  "primary-container": "#770200",
  "on-primary-container": "#ff7965",
  secondary: "#ffb4a8",
  "on-secondary": "#581d15",
  "secondary-container": "#77352b",
  "on-secondary-container": "#fca092",
  tertiary: "#bdc2ff",
  "on-tertiary": "#00149f",
  "tertiary-container": "#0018b4",
  "on-tertiary-container": "#8e99ff",
  error: "#ffb4ab",
  "on-error": "#690005",
  "error-container": "#93000a",
  "on-error-container": "#ffdad6",
  surface: "#131313",
  "surface-dim": "#131313",
  "surface-bright": "#393939",
  "surface-container-lowest": "#0e0e0e",
  "surface-container-low": "#1b1b1b",
  "surface-container": "#1f1f1f",
  "surface-container-high": "#2a2a2a",
  "surface-container-highest": "#353535",
  "on-surface": "#e2e2e2",
  "on-surface-variant": "#c6c6c6",
  outline: "#919191",
  "outline-variant": "#474747",
  "inverse-surface": "#e2e2e2",
  "inverse-on-surface": "#303030",
  "inverse-primary": "#af3021",
  scrim: "#000000",
  shadow: "#000000",
  "surface-tint": "#ffb4a8",
  background: "#131313",
  "on-background": "#e2e2e2",
} as const;

export const M3_SPMS_LIGHT = {
  primary: "#bb0011",
  "on-primary": "#ffffff",
  "primary-container": "#e61a20",
  "on-primary-container": "#fffbff",
  secondary: "#5e5e5e",
  "on-secondary": "#ffffff",
  "secondary-container": "#e2e2e2",
  "on-secondary-container": "#646464",
  tertiary: "#006290",
  "on-tertiary": "#ffffff",
  "tertiary-container": "#007bb4",
  "on-tertiary-container": "#fcfcff",
  error: "#ba1a1a",
  "on-error": "#ffffff",
  "error-container": "#ffdad6",
  "on-error-container": "#93000a",
  surface: "#f9f9f9",
  "surface-dim": "#dadada",
  "surface-bright": "#f9f9f9",
  "surface-container-lowest": "#ffffff",
  "surface-container-low": "#f3f3f3",
  "surface-container": "#eeeeee",
  "surface-container-high": "#e8e8e8",
  "surface-container-highest": "#e2e2e2",
  "on-surface": "#1b1b1b",
  "on-surface-variant": "#474747",
  outline: "#777777",
  "outline-variant": "#c6c6c6",
  "inverse-surface": "#303030",
  "inverse-on-surface": "#f1f1f1",
  "inverse-primary": "#ffffff",
  scrim: "#000000",
  shadow: "#000000",
  "surface-tint": "#c00012",
  background: "#f9f9f9",
  "on-background": "#1b1b1b",
} as const;

export const M3_SPMS_DARK = {
  primary: "#e61a20",
  "on-primary": "#ffffff",
  "primary-container": "#93000b",
  "on-primary-container": "#ffffff",
  secondary: "#c6c6c6",
  "on-secondary": "#303030",
  "secondary-container": "#474747",
  "on-secondary-container": "#c6c6c6",
  tertiary: "#8dcdff",
  "on-tertiary": "#00344f",
  "tertiary-container": "#5ab6f5",
  "on-tertiary-container": "#000000",
  error: "#ffb4ab",
  "on-error": "#690005",
  "error-container": "#93000a",
  "on-error-container": "#ffdad6",
  surface: "#131313",
  "surface-dim": "#131313",
  "surface-bright": "#393939",
  "surface-container-lowest": "#0e0e0e",
  "surface-container-low": "#1b1b1b",
  "surface-container": "#1f1f1f",
  "surface-container-high": "#2a2a2a",
  "surface-container-highest": "#353535",
  "on-surface": "#e5e5e5",
  "on-surface-variant": "#cccccc",
  outline: "#919191",
  "outline-variant": "#474747",
  "inverse-surface": "#e2e2e2",
  "inverse-on-surface": "#303030",
  "inverse-primary": "#c00012",
  scrim: "#000000",
  shadow: "#000000",
  "surface-tint": "#e61a20",
  background: "#131313",
  "on-background": "#e2e2e2",
} as const;

export const M3_EST_LIGHT = {
  primary: "#bb0014",
  "on-primary": "#ffffff",
  "primary-container": "#e0282a",
  "on-primary-container": "#fffbff",
  secondary: "#5e5e5e",
  "on-secondary": "#ffffff",
  "secondary-container": "#e2e2e2",
  "on-secondary-container": "#646464",
  tertiary: "#00647e",
  "on-tertiary": "#ffffff",
  "tertiary-container": "#007f9f",
  "on-tertiary-container": "#fafdff",
  error: "#ba1a1a",
  "on-error": "#ffffff",
  "error-container": "#ffdad6",
  "on-error-container": "#93000a",
  surface: "#f9f9f9",
  "surface-dim": "#dadada",
  "surface-bright": "#f9f9f9",
  "surface-container-lowest": "#ffffff",
  "surface-container-low": "#f3f3f3",
  "surface-container": "#eeeeee",
  "surface-container-high": "#e8e8e8",
  "surface-container-highest": "#e2e2e2",
  "on-surface": "#1b1b1b",
  "on-surface-variant": "#474747",
  outline: "#777777",
  "outline-variant": "#c6c6c6",
  "inverse-surface": "#303030",
  "inverse-on-surface": "#f1f1f1",
  "inverse-primary": "#ffffff",
  scrim: "#000000",
  shadow: "#000000",
  "surface-tint": "#bf0516",
  background: "#f9f9f9",
  "on-background": "#1b1b1b",
} as const;

export const M3_EST_DARK = {
  primary: "#e0282a",
  "on-primary": "#ffffff",
  "primary-container": "#93000d",
  "on-primary-container": "#ffffff",
  secondary: "#c6c6c6",
  "on-secondary": "#303030",
  "secondary-container": "#474747",
  "on-secondary-container": "#c6c6c6",
  tertiary: "#72d3f7",
  "on-tertiary": "#003545",
  "tertiary-container": "#56bade",
  "on-tertiary-container": "#000000",
  error: "#ffb4ab",
  "on-error": "#690005",
  "error-container": "#93000a",
  "on-error-container": "#ffdad6",
  surface: "#131313",
  "surface-dim": "#131313",
  "surface-bright": "#393939",
  "surface-container-lowest": "#0e0e0e",
  "surface-container-low": "#1b1b1b",
  "surface-container": "#1f1f1f",
  "surface-container-high": "#2a2a2a",
  "surface-container-highest": "#353535",
  "on-surface": "#e5e5e5",
  "on-surface-variant": "#cccccc",
  outline: "#919191",
  "outline-variant": "#474747",
  "inverse-surface": "#e2e2e2",
  "inverse-on-surface": "#303030",
  "inverse-primary": "#bf0516",
  scrim: "#000000",
  shadow: "#000000",
  "surface-tint": "#e0282a",
  background: "#131313",
  "on-background": "#e2e2e2",
} as const;

export const M3 = {
  preedanext: { light: M3_PREEDANEXT_LIGHT, dark: M3_PREEDANEXT_DARK },
  pk: { light: M3_PK_LIGHT, dark: M3_PK_DARK },
  sp: { light: M3_SP_LIGHT, dark: M3_SP_DARK },
  personal: { light: M3_PERSONAL_LIGHT, dark: M3_PERSONAL_DARK },
  preedagroup: { light: M3_PREEDAGROUP_LIGHT, dark: M3_PREEDAGROUP_DARK },
  spms: { light: M3_SPMS_LIGHT, dark: M3_SPMS_DARK },
  est: { light: M3_EST_LIGHT, dark: M3_EST_DARK },
} as const;

export type M3Brand = keyof typeof M3;
export type M3Role = keyof (typeof M3)[M3Brand]["light"];
